import React from "react";
import {connect} from "react-redux";

import {postMessageToParent} from "../lookMessaging";
import {GROHE_POST_MESSAGES_ACTIONS} from "../iframeIntegration";
import {getLookId, getPostCartItemsList} from "../lookNavigation/lookFunctions2";
import {setIframeIntegrationRequest} from "../../../actions/iframeIntegrationFunctions";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {saveQuote} from "../../../api/server-api";
import {renderErrorPopup} from "../../../api/api-popups";
import WithLoginPostMessage from "./withLoginPostMessage";
import {isIframe} from "../../../misc/helpers";
import {showQuoteSavedNotification} from "../../ui/successNotification";
import Analytics from "../../../analytics";
import {getAnalyticsEcommerceValues} from "../../../analyticsEcommerceParams";

const WithSavePostMessage = (props) => {

  const {cartItems, children, activePreset, bvPresets, userIsLoggedIn, setIframeIntegrationRequest, fabricatorData} = props;
  const isLixil = isIframe() && fabricatorData.isLixil;

  const savePostMessage = async (loginPostMessage, cartItem = null) => {

    const {currency, value, items} = getAnalyticsEcommerceValues();
    Analytics.sendEcommerceEvent("add_to_wishlist", {currency, value, items});

    if (!userIsLoggedIn && isLixil) {
      loginPostMessage();
      return false
    }
    const wishlistLines = getPostCartItemsList(cartItem ? [cartItem] : cartItems);
    if (!wishlistLines.length && isLixil) {
      renderErrorPopup("No items in your list", null, "Something went wrong");
      return false
    }
    loaderEnable();
    saveQuote({
      submit: true,
      showReceipt: false
    })
      .then((responseData) => {
        if (isLixil) {
          let lookId = getLookId(activePreset, bvPresets);
          let savePostData = {
            "EventType": GROHE_POST_MESSAGES_ACTIONS.save,
            "LookId": lookId + "",
            "WishlistRequestLines": wishlistLines
          }
          if(responseData.jobId) {
            savePostData["VisualizerId"] = responseData.jobId + "";
          }
          setIframeIntegrationRequest(savePostData);
          window.postMessageIsExecuting = true;
          postMessageToParent(savePostData);
        } else {
          showQuoteSavedNotification();
          loaderDisable();
        }
      })
      .catch((error) => {
        renderErrorPopup("Server "+new Error(error));
        if (!isLixil) {
          loaderDisable();
        }
      })
  }

  return (
    <WithLoginPostMessage>
      {(loginPostMessage) => children(savePostMessage.bind(this, loginPostMessage))}
    </WithLoginPostMessage>
  )
};

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {activePreset, bvPresets} = store.bathroomVisualizerState;
  const {userIsLoggedIn} = store.userState;
  const fabricatorData = store.fabricatorState;
  return {
    cartItems,
    activePreset,
    userIsLoggedIn,
    bvPresets,
    fabricatorData,
  }
};

const mapDispatchToProps = {
  setIframeIntegrationRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(WithSavePostMessage)
